import { render, staticRenderFns } from "./CustomerTabAddresses.vue?vue&type=template&id=23d58d7a&scoped=true"
import script from "./CustomerTabAddresses.vue?vue&type=script&lang=ts"
export * from "./CustomerTabAddresses.vue?vue&type=script&lang=ts"
import style0 from "./CustomerTabAddresses.vue?vue&type=style&index=0&id=23d58d7a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23d58d7a",
  null
  
)

export default component.exports